import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { AdyenEnhancedFormT } from "./use-adyen-form";
import { SwarovskiButton } from "../../../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { CardDataBinInfo } from "./types";
import { jsHooks } from "@swo/shared";
import cn from "classnames";
import { CheckoutPaymentMethodSelectionState_CreditCard } from "../state/payment-methods";
import { fontSize } from "../../../../../styles/fonts";
import { CCState } from "../checkout-steps/03-payment-method/types";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../../../components/T";

type AdyenTranslations = {
  creditCardSave: string | TranslatedValue;
  creditCardEdit: string | TranslatedValue;
  creditCardClose: string | TranslatedValue;
};

export const AdyenComponent: ReactTFC<{
  onSaved: (v: CheckoutPaymentMethodSelectionState_CreditCard) => void;
  screen: CCState;
  translations: AdyenTranslations;
  formState: AdyenEnhancedFormT;
  onEditCardDataRequested: () => void;
}> = props => {
  const { screen, formState, onEditCardDataRequested } = props;

  const className = cn(
    screen.tag === "input-card-data" ? "show" : "hide",
    jsHooks.checkout.paymentMethods.creditCard.iframeWrapper,
  );

  function component() {
    switch (screen.tag) {
      case "show-saved-card": {
        return (
          <React.Fragment>
            <div>
              <MaskedCardNumber bin={screen.data.bin} />
            </div>

            <div
              css={css`
                margin-top: 20px;

                display: flex;
                justify-content: flex-end;

                color: ${CSS_COLORS.Green};
              `}
            >
              <SwarovskiButton variant={"plain-underline"} as={"button"} onClick={onEditCardDataRequested}>
                <T>{props.translations.creditCardEdit}</T>
              </SwarovskiButton>
            </div>
          </React.Fragment>
        );
      }

      case "input-card-data": {
        const { isReady, validData, brand, bin } = props.formState;

        return (
          <div className={"adyen-component-input"}>
            <SwarovskiButton
              variant={"green"}
              as={"button"}
              disabled={!isReady || !validData}
              className={jsHooks.checkout.paymentMethods.creditCard.save}
              onClick={
                brand && validData && bin
                  ? () =>
                      props.onSaved({
                        tag: "credit-card",
                        brand,
                        bin,
                        encryptedCartData: { ...validData.paymentMethod, holderName: undefined },
                        browserInfo: validData.browserInfo,
                      })
                  : undefined
              }
            >
              <T>{props.translations.creditCardSave}</T>
            </SwarovskiButton>
          </div>
        );
      }
    }
  }

  return (
    <div>
      <div
        className={className}
        css={css`
          &.show {
            display: block;
          }

          &.hide {
            display: none;
          }
        `}
      >
        {formState.IFrameComponent}
      </div>

      {component()}
    </div>
  );
};

const MaskedCardNumber: ReactTFC<{ bin: CardDataBinInfo }> = props => {
  const fourAsterisks = (
    <span
      css={css`
        letter-spacing: -2px;
      `}
    >
      ••••
    </span>
  );

  return (
    <span className={"u-fw-300"} css={fontSize.x25}>
      {props.bin.binValue.split("").slice(0, 4).join("")} {fourAsterisks} {fourAsterisks} {fourAsterisks}
    </span>
  );
};
